module.exports = __webpack_public_path__ + "static/EnmTX_BosDragon_L_B_cl-75fba979d188e4e9a3f59b920a91928b.gif";